module.exports = __webpack_public_path__ + "images/for_company_page/voice-tiger_4a74d2ae3c3569f8ce0ab40bc9e30eef.jpg";